import type { MessageId } from "@domain/intl/useTranslation";

import type { AgentReportData, ReportLine } from "./runner/types";

type Translate = (id: MessageId, values?: Record<string, string | number>) => string;

/** Resolves the label placeholders of a report line with `t` and formats it. */
export const reportLineText = (t: Translate, line: ReportLine): string => {
    const labels = Object.fromEntries(Object.entries(line.labels ?? {}).map(([key, id]) => [key, t(id)]));
    return t(line.textId, { ...line.values, ...labels });
};

/** The report as plain text: both sections, one dash line per entry. */
export const reportToPlainText = (t: Translate, report: AgentReportData, company: string | undefined): string => {
    const section = (heading: string, lines: ReportLine[], emptyId: MessageId) => [
        heading,
        ...(lines.length > 0 ? lines.map((l) => `- ${reportLineText(t, l)}`) : [`- ${t(emptyId)}`]),
    ];
    return [
        [t("app.agent.title"), company, String(report.year)].filter(Boolean).join(" - "),
        "",
        ...section(t("app.agent.report.sectionDone"), report.done, "app.agent.report.nothingDone"),
        "",
        ...section(t("app.agent.report.sectionOpen"), report.open, "app.agent.report.nothingOpen"),
        "",
    ].join("\n");
};
